export default {
  data () {
    return {
      isModuleAdmin: false,
      isModuleView: true
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    // 查询当前模块中，平台下发的权限
    hasModuleAuth (val){
      let ZJYUSERINFO = null
      let moduleAuthList = ''
      if (window.ZJYUSERINFO){
        ZJYUSERINFO = JSON.parse(window.ZJYUSERINFO)
        moduleAuthList = ZJYUSERINFO.authorityCodes.join('&')
      }
      return moduleAuthList.includes(val)
    },
    // 查询是否有权限
    hasPermissonList (val){
      const moduleAuthList = sessionStorage.getItem('ModuleAuthList')
      return moduleAuthList.includes(val)
    }
  }
}
